module.exports = __webpack_public_path__ + "img/0Q3A2198_L_BlackMatted.ca791a1c.jpg";